import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';

/**
 * ApisService Work sending request to backend.
 * @author Santiago Vasquez Olarte. <santiago.vasquez@ingeneo.com>
 * @copyright (c) 2020 INGENEO S.A.S.
 */

@Injectable({
  providedIn: 'root'
})

export class ApisService {

  public headers = new HttpHeaders();

  constructor(public http: HttpClient) {}

  applyFilters(form = null) {
    try {
      if (form == null) {
        form = {
          type_vehicle: localStorage.getItem('typeVehicle'),
          action: "all"
        }
      } else {
        form['type_vehicle'] = localStorage.getItem('typeVehicle');
      }

      const url =  environment.url_base + 'apply-filters';
      return new Promise(resolve => {
        this.http.post(url, form, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  updateImageDocumentsVehicle(form) {
    try {
      const url =  environment.url_base + 'update-image-document-vehicle';
      return new Promise(resolve => {
        this.http.post(url, form, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  updateImageDocumentsUser(form) {
    try {
      const url =  environment.url_base + 'update-image-document-user';
      return new Promise(resolve => {
        this.http.post(url, form, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  UpdateRequestChangeInfoDocuments(form) {
    try {
      const url =  environment.url_base + 'request-change-info-documents';
      return new Promise(resolve => {
        this.http.post(url, form, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  updateInfoVehicle(form) {
    try {
      const url =  environment.url_base + 'update-vehicle-web';
      return new Promise(resolve => {
        this.http.post(url, form, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  AnswerTicket(form) {
    try {
      const url =  environment.url_base + 'answer-ticket-admin';
      return new Promise(resolve => {
        this.http.post(url, form, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  GetSupportPending() {
    try {
      const url = environment.url_base + 'get-tickets-histories-by-support-id-web';
      return new Promise(resolve => {
        this.http.post(url, { type: localStorage.getItem('typeVehicle') }, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  GetRequestPending() {
    try {
      const url = environment.url_base + 'get-request-pending';
      return new Promise(resolve => {
        this.http.post(url, { type: localStorage.getItem('typeVehicle') }, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  SaveSettings(data) {
    try {
      const url = environment.url_base + 'save-settings';
      return new Promise(resolve => {
        this.http.post(url, data, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  updateAllBagdeToFalse(type_user) {
    try {
      const url = environment.url_base + 'update-badge';
      return new Promise(resolve => {
        this.http.post(url, { action: type_user }, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  GetRequestPendingLicense() {
    try {
      const url = environment.url_base + 'get-request-pending-license';
      return new Promise(resolve => {
        this.http.post(url, '', { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  GetRequestPendingVehicle() {
    try {
      const url = environment.url_base + 'get-request-pending-vehicle';
      return new Promise(resolve => {
        this.http.post(url, '', { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  acceptDocumentsVehicle(form, action) {
    try {
      let data = {
        form: form,
        action: action
      };
      const url =  environment.url_base + 'accept-documents-driver';
      return new Promise(resolve => {
        this.http.post(url, data, { headers: this.headers }).subscribe(result => {
          return resolve(result);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  RequestChangeInformation(form, action) {
    try {
      let data = {
        form: form,
        action: action
      };
      const url =  environment.url_base + 'request-change-information';
      return new Promise(resolve => {
        this.http.post(url, data, { headers: this.headers }).subscribe(result => {
          return resolve(result);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  RejectDocumentsVehicle(form, action) {
    try {
      let data = {
        form: form,
        action: action
      };
      const url =  environment.url_base + 'reject-documents-vehicle';
      return new Promise(resolve => {
        this.http.post(url, data, { headers: this.headers }).subscribe(result => {
          return resolve(result);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  ChangeStateTicket(form, action) {
    try {
      form['action'] = action;
      const url =  environment.url_base + 'change-state-ticket';
      return new Promise(resolve => {
        this.http.post(url, form, { headers: this.headers }).subscribe(result => {
          return resolve(result);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  RejectDocumentsDriver(form, action) {
    try {
      let data = {
        form: form,
        action: action
      };
      const url =  environment.url_base + 'reject-documents-driver';
      return new Promise(resolve => {
        this.http.post(url, data, { headers: this.headers }).subscribe(result => {
          return resolve(result);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  acceptDocumentsUser(form, action) {
    try {
      let data = {
        form: form,
        action: action
      };
      const url =  environment.url_base + 'accept-documents-user';
      return new Promise(resolve => {
        this.http.post(url, data, { headers: this.headers }).subscribe(result => {
          return resolve(result);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  sendNotificationsPush(form) {
    try {
      let data = {
        form: form
      };
      const url =  environment.url_base + 'send-notification-push';
      return new Promise(resolve => {
        this.http.post(url, data, { headers: this.headers }).subscribe(result => {
          return resolve(result);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE VIDEO');
      console.error(e);
    }
  }

  uploadMutipleCenso(data) {
    try {
      const url = environment.url_base + 'upload-multiple-censo';
      return new Promise(resolve => {
        this.http.post(url, data, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE CENSOS');
      console.error(e);
    }
  }

  GetDriversPendingByAccept() {
    try {
      const url = environment.url_base + 'get-drivers-pending-by-accept';
      return new Promise(resolve => {
        this.http.post(url, '', { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE CENSOS');
      console.error(e);
    }
  }

  GetSettings() {
    try {
      const url = environment.url_base + 'get-settings';
      return new Promise(resolve => {
        this.http.get(url, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE CENSOS');
      console.error(e);
    }
  }

  searchRejects(data) {
    try {
      const url = environment.url_base + 'get-message-reject';
      return new Promise(resolve => {
        this.http.post(url, data, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE CENSOS');
      console.error(e);
    }
  }

  report(form) {
    try {
      const url = environment.url_base + 'report';
      return new Promise(resolve => {
        this.http.post(url, form, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE QUESTIONS');
      console.error(e);
    }
  }

  signIn(form) {
    try {
      const url = environment.url_base + 'sign-in-web';
      return new Promise(resolve => {
        this.http.post(url, form, { headers: this.headers }).subscribe(data => {
          return resolve(data);
        }, err => {
          return resolve(err.json());
        });
      });
    } catch (e) {
      console.error('!!!!ERROR IN SAVE QUESTIONS');
      console.error(e);
    }
  }

}
